import * as DataUtils from './DataUtils.js';

export const GetPais = async (idPais) => {
  return DataUtils.FetchObject('paises/' + idPais);
};
